import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ClientAuthProvider } from "@/contexts/ClientAuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import About from "@/pages/About";
import BranchPage from "@/pages/BranchPage";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BusinessCards from "@/pages/BusinessCards";
import Brochure from "@/pages/Brochure";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminContactRequests from "@/pages/AdminContactRequests";
import BannerPage from "@/pages/Banner";
import SocialMedia from "@/pages/SocialMedia";
import ClientLogin from "@/pages/ClientLogin";
import ClientPortal from "@/pages/ClientPortal";
import AdminClientPortal from "@/pages/AdminClientPortal";
import { BRANCHES } from "@/lib/brand";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const hideFooter = pathname.startsWith("/admin") || pathname.startsWith("/espace-client");
  const showChat = !pathname.startsWith("/admin") && !pathname.startsWith("/espace-client");
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      {!hideFooter && <Footer />}
      {showChat && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#0a0a0a] min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <ClientAuthProvider>
            <ScrollToTop />
            <Toaster position="top-right" theme="dark" richColors />
            <Shell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/studio" element={<BranchPage branch={BRANCHES.studio} />} />
                <Route path="/securite" element={<BranchPage branch={BRANCHES.securite} />} />
                <Route path="/proprete" element={<BranchPage branch={BRANCHES.proprete} />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/espace-client/login" element={<ClientLogin />} />
                <Route path="/espace-client" element={<ClientPortal />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/cartes-visite" element={<BusinessCards />} />
                <Route path="/admin/depliant" element={<Brochure />} />
                <Route path="/admin/bache" element={<BannerPage />} />
                <Route path="/admin/reseaux-sociaux" element={<SocialMedia />} />
                <Route path="/admin/clients" element={<AdminCustomers />} />
                <Route path="/admin/messages" element={<AdminContactRequests />} />
                <Route path="/admin/espace-client" element={<AdminClientPortal />} />
              </Routes>
            </Shell>
          </ClientAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
